import React, { Component } from 'react';
import {
    Grid, Row, Col,
    FormGroup, ControlLabel, FormControl
} from 'react-bootstrap';
import decode from 'jwt-decode';
import _ from 'lodash';
import SweetAlert from "react-bootstrap-sweetalert";


import ContractModal from '../ContractModal/ContractModal.jsx';
import Card from '../../components/Card/Card.jsx';

import Button from '../../elements/CustomButton/CustomButton.jsx';

import AuthService from '../../services/AuthService.js';
import IncubationService from '../../services/IncubationService.js';

class LoginPage extends Component{
    constructor(props){
      super(props);
      this.state = {
          cardHidden: true,
          contractOpened: false,
          contrato: null,
          userId: null,
          alert: null,
      }
      this.handleChange = this.handleChange.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.closeContractModal = this.closeContractModal.bind(this);
      this.handleContinueModal = this.handleContinueModal.bind(this);
      this.checkContract = this.checkContract.bind(this);
      this.errorAlert = this.errorAlert.bind(this);
      this.Auth = new AuthService();
      this.incubationService = new IncubationService();
    }
    componentDidMount(){
      setTimeout(function() { this.setState({cardHidden: false}); }.bind(this), 700);
    }
    componentWillMount(){
      if(this.Auth.loggedIn()) {
        this.props.history.replace('/');
      }
    }
    closeContractModal() {
      this.setState({ contractOpened: false });
      this.Auth.logout();
    }
    errorAlert(message) {
      console.log(message);
      this.setState({
        alert: (
          <SweetAlert
            error
            style={{ display: "block", marginTop: "-100px" }}
            title="Error"
            onConfirm={() => this.setState({alert: null})}
            confirmBtnBsStyle="danger"
            confirmBtnText="Aceptar"
          >
            {message}
          </SweetAlert>
        )
      });
    }
    handleContinueModal(idmiembro, idcontrato) {
      this.setState({ contractOpened: false });
      this.incubationService.signContract(idmiembro, idcontrato)
      .then(res => {
        this.checkContract(this.state.userId);
      })
      .catch(err =>{
        this.errorAlert('Hubo un error al procesar la información del contrato');
      });
    }
    render(){
        return (
          <div>
            {this.state.alert}
            <Grid>
              <Row>
                    <Col md={4} sm={6} mdOffset={4} smOffset={3}>
                        <form onSubmit={this.handleFormSubmit}>
                            <Card
                                hidden={this.state.cardHidden}
                                textCenter
                                title="Acceso"
                                content={
                                    <div>
                                        <FormGroup>
                                            <ControlLabel>
                                                Correo electrónico
                                            </ControlLabel>
                                            <FormControl
                                                placeholder="Ingrese su email"
                                                type="email"
                                                name="email"
                                                autoComplete="email"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>
                                                Contraseña
                                            </ControlLabel>
                                            <FormControl
                                                placeholder="Contraseña"
                                                type="password"
                                                name="password"
                                                autoComplete="current-password"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </div>
                                }
                                legend={
                                    <Button type="submit" bsStyle="info" fill wd>
                                        Ingresar
                                    </Button>
                                }
                                ftTextCenter
                            />
                        </form>
                    </Col>
                </Row>
            </Grid>
            {this.state.contractOpened &&
              <ContractModal onClose={this.closeContractModal} onContinue={this.handleContinueModal} contrato={this.state.contrato}/>
            }
          </div>
        );
    }
    handleChange(e){
      this.setState(
          {
              [e.target.name]: e.target.value
          }
      )
    }
    handleFormSubmit(e){
       e.preventDefault();
       this.Auth.login(this.state.email,this.state.password)
           .then(res =>{
               const user = decode(localStorage.getItem('id_token'));
               this.checkContract(user.id);
               this.setState({userId: user.id});
           })
           .catch(err =>{
             this.errorAlert('El usuario o la contraseña son incorrectos!');
           })
   }

   checkContract(id) {
     this.incubationService.getUserLoginContract(id)
     .then(res => {
       if(_.isEmpty(res['user-contract'])) {
         window.location.reload();
       } else {
         this.setState({ contractOpened: true, contrato: res['user-contract'] });
       }
     })
     .catch(err =>{
        this.errorAlert('Hubo un error al obtener la información del contrato');
     });
   }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx